/** A failed picker/option-list query: what failed, why, and how to retry. */
export type QueryLoadFailure = {
  title: string;
  error: unknown;
  onRetry: () => void;
};

/**
 * Load failure of an option-list query, or `undefined` while it has not failed,
 * so pickers can show the error (with retry) instead of a false "empty list".
 */
export function queryLoadFailure(
  query: { error: unknown; refetch: () => unknown },
  title: string,
): QueryLoadFailure | undefined {
  if (!query.error) return undefined;
  return { title, error: query.error, onRetry: () => void query.refetch() };
}
